import { Pipe, PipeTransform } from '@angular/core';
import * as numeral from 'numeral';
import * as _ from 'lodash';

/**
 * Generated class for the FormatDistancePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatDistance',
})
export class FormatDistancePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(route: any, ...args) {
    // When restarting a trip, an exception was being thrown
    // the try catch is to ignore the error.
    try {
      const r = route,
        distance = _.sumBy(r.properties.legs, l => {
          return _.get(l, 'distance.value');
        }),
        distanceStr = numeral(_.round(distance * 0.000621371, 0)).format('0,0');

      if (args[0] === 'percentComplete') {
        return _.round((args[1] / _.parseInt(distanceStr)) * 100);
      } else {
        return distanceStr + 'mi';
      }
    } catch {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-distance/format-distance.ts